import DashboardOffers from "./components/layout/dashboard-offers.vue"
import DevicesList from "./components/layout/devices-list.vue"
import ProductDetailDevices from "./components/layout/product-detail.vue"
import HomeOffers from "./components/layout/home-offers.vue"
import BrandList from "./components/layout/brand-list.vue"
import TypesOfBrands from "./components/layout/types-of-brands.vue"
import SearchCategories from "./components/layout/elements/search-categories.vue"
import HeaderDashboard from "./components/layout/elements/header-dashboard.vue"

import devicesScreen from "./components/layout/device-mobile-types-offers.vue"
import hotelsScreen from "./components/layout/hotel-offers.vue"
import servicesScreen from "./components/offers/services.vue"
import checkoutScreen from "./components/layout/checkout-screen.vue"
import createOffer from "./components/layout/create-offer.vue"
import editOffer from "./components/layout/edit-offer.vue"

export default {
    '/': {
        name: 'DashboardOffers',
        component: DashboardOffers
    },
    '/administrator/offers': {
        name: 'administrator-offers', //index (admin)
        component: lazyLoading('./components/offers/list-offers')
    },
    '/administrator/provider': {
        name: 'administrator-provider',
        component: lazyLoading('./components/provider/list')
    },
    '/administrator/orders': {
        name: 'administrator-orders',
        component: lazyLoading('./components/orders/index')
    },
    '/administrator/services': {
        name: 'administrator-orders',
        component: lazyLoading('./components/orders/services')
    },
    '/administrator/comments': {
        name: 'comments',
        component: lazyLoading('./components/offers/comments')
    },
    '/administrator/provider/:id': {
        name: 'administrator-provider-edit',
        component: lazyLoading('./components/provider/edit')
    },
    '/create-provider': {
        name: 'create-provider',
        component: lazyLoading('./components/provider/create')
    },
    '/list-products/:id': {
        name: 'list-products',
        component: lazyLoading('./components/offers/list-products')
    },
    '/offers/:id/information': {
        name: 'offers-information', //offer info (admin)
        component: lazyLoading('./components/offers/offers-information')
    },
    '/client-offers': {
        name: 'client-offers', //listado de ofertas para el cliente (client)
        component: lazyLoading('./components/offers/client-offers')
    },
    '/client-offers/:id': {
        name: 'client-offers', //listado de ofertas para el cliente (client)
        component: lazyLoading('./components/offers/client-offers')
    },
    '/new-client-offers/:id': {
        name: 'new-client-offers', //listado de ofertas para el cliente (client)
        component: lazyLoading('./components/offers/offers-information-new')
    },
    '/client-offers-all/:service_id/:id': {
        name: 'client-offers-all', //listado de ofertas para el cliente (client)
        component: lazyLoading('./components/offers/new-board')
    },
    '/apply-offer/:id': {
        name: 'apply-offer', //solictar offerta para el empleado (call center)
        component: lazyLoading('./components/offers/apply-offer')
    },
    '/offers/:id/information/:companyId': {
        name: 'purchased-offers', //offer client info (admin)
        component: lazyLoading('./components/offers/offers-clients-info')
    },
    '/dashboard-offers': {
        name: 'DashboardOffers',
        component: DashboardOffers
    },
    '/devices-list': {
        name: 'DevicesList',
        component: DevicesList
    },
    '/product-detail/:id': {
        name: 'ProductDetailDevices',
        component: ProductDetailDevices
    },
    '/device-types': {
        name: 'mobile-device-types',
        component: devicesScreen
    },
    '/hotels': {
        name: 'hotels',
        component: hotelsScreen
    },
    '/services/:id': {
        name: 'services',
        component: servicesScreen
    },
    '/offers/:id/checkout': {
        name: 'product-checkout',
        component: checkoutScreen
    },
    '/create-offer': {
        name: 'create-offer',
        component: createOffer
    },
    '/edit-offer/:id': {
        name: 'edit-offer',
        component: editOffer
    },
    '/home-offers': { // Home Offers
        name: 'home-offers',
        component: HomeOffers
    },
    '/brand-list': { // Brand List
        name: 'brand-list',
        component: BrandList
    },
    '/types-of-brands': { // Devices Categoty List
        name: 'types-of-brands',
        component: TypesOfBrands
    },
    '/search-categories': { // Search Categories
        name: 'search-categories',
        component: SearchCategories
    },
    '/header-dashboard': { // Header Dashboard
        name: 'header-dashboard',
        component: HeaderDashboard
    }

};


// WEBPACK FOOTER //
// ./src/routes.old.js